import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface StyleguideSectionProps extends ExpandStyles<StyleguideSectionStyles> {
    title: string;
    variant?: TypographyPresentationProps["variant"];
}

export interface StyleguideSectionStyles {
    container?: InjectableCss;
    title?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

const styleguideSectionStyles: StyleguideSectionStyles = {
    container: {
        css: css`
            ${spacingStyles()}
        `,
    },
    title: {
        variant: "h2",
    },
};

const StyleguideSection: FC<StyleguideSectionProps> = ({
    children,
    title,
    variant,
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(styleguideSectionStyles, extendedStyles, overridedStyles);

    if (!children) {
        return null;
    }

    return (
        <StyledWrapper {...styles?.container}>
            <Typography {...styles?.title} variant={variant || styles.title?.variant}>
                {title}
            </Typography>
            <StyledWrapper {...styles?.wrapper}>{children}</StyledWrapper>
        </StyledWrapper>
    );
};

export default StyleguideSection;
